import NegotiationList, {
  NegotiationRow,
} from '../shared/NegotiationList';
import { asRecord, firstNumber, firstText } from '../shared/records';

export type NegotiationHistoryItem = NegotiationRow;

const toHistoryItem = (item: Record<string, unknown>): NegotiationHistoryItem => {
  const option = asRecord(item.opcaoPagamento);
  const client = asRecord(asRecord(item.consulta)?.dadosConsulta);

  return {
    idNegociacao: firstText(item.idNegociacao, item.id),
    nome: firstText(item.nome, item.nomeCliente, client?.nome),
    cpf: firstText(item.cpf, item.cpfCliente, client?.cpf).replace(/\D/g, ''),
    data: firstText(item.dataCriacao, item.data, item.dataNegociacao, item.dataAcordo),
    valorOriginal: firstNumber(option?.valorOriginal, item.valorOriginal),
    desconto: firstNumber(option?.valorDesconto, item.desconto, item.valorDesconto),
    entrada: firstNumber(
      option?.valorComDesconto,
      item.entrada,
      item.valorEntrada,
      item.valorComDesconto,
    ),
    parcelas: firstNumber(option?.parcelas, item.parcelas, item.quantidadeParcelas),
    vencimento: firstText(
      item.vencimentoPrimeiroPagamento,
      option?.vencimento,
      item.vencimento,
      item.dataVencimento,
    ),
    status: firstText(item.status),
    operador: firstText(item.nomeOperador, item.operador, item.cpfOperador),
  };
};

const DebtNegotiationHistory = (): JSX.Element => (
  <NegotiationList
    detailPath="/negociacao-dividas/historico/detalhes"
    emptyMessage="Nenhuma negociação encontrada."
    errorMessage="Não foi possível consultar o histórico."
    mapItem={toHistoryItem}
  />
);

export default DebtNegotiationHistory;
